import comp from "./AssessmentLibrary";
export default comp;
